/* CheapBats home page: embed a live collection (grid + Search & Discovery filters + "Show more")
   inside the index template. 2026-09-07. Pairs with sections/cb-home-collection-embed.liquid,
   assets/cb-facet-filters.js (scoped facet JS) and templates/collection.home-embed.json (12/page). */
(function () {
  'use strict';
  window.cbRailLinks = true; // CB_RAIL_LINKS_LIVE (toggled by cb_parity_live.py)
  var ID_ATTRS = ['id', 'for', 'aria-labelledby', 'aria-controls', 'aria-describedby'];
  // Suffix every id (and references to it) so two embeds on one page never collide.
  window.cbSuffixIds = function (html, key) {
    return html.replace(/(\s)(id|for|aria-labelledby|aria-controls|aria-describedby)="([^"]+)"/g, function (m, sp, attr, val) {
      if (attr === 'id' && /^shopify-section-/.test(val)) return m;
      var vals = val.split(/\s+/).map(function (v) { return v.endsWith('--' + key) ? v : v + '--' + key; });
      return sp + attr + '="' + vals.join(' ') + '"';
    });
  };


  // ---- Home card treatment (Mike approved 9/7): BatReviews.com Top Pick mark top-left (from custom.batreviews_pick,
  // set by batreviews_picks.py), savings pill under the price, vendor logo bottom-right, no Choose Options button.
  var LOGOS = { miken: ['brand-logo-miken-white.png', 1], worth: ['brand-logo-worth-white.png', 1], easton: ['brand-logo-easton-white.png', 1], marucci: ['marucci-red.svg', 0], rawlings: ['brand-logo-rawlings.webp', 0, 'sq'], mizuno: ['brand-logo-mizuno-black.png', 0, 'sq'], victus: ['Victus_Black_Logo.png', 0, 'sq'], 'axe bat': ['brand-logo-axe-white.png', 1], 'lizard skins': ['Lizard_Skins_Header_Logo_2025_small_horizontal.png', 0] };
  window.cbDressCards = function (root, picks) {
    root.querySelectorAll('.js-pagination-result .card').forEach(function (c, idx) {
      if (c.dataset.cbDressed) return; c.dataset.cbDressed = '1';
      var v = ((c.querySelector('[class*="vendor"]') || {}).textContent || '').toLowerCase();
      var key = Object.keys(LOGOS).find(function (k) { return v.indexOf(k) > -1; });
      if (key) { var img = document.createElement('img'); img.src = 'https://cdn.shopify.com/s/files/1/0649/6147/8809/files/' + LOGOS[key][0]; img.alt = v; img.loading = 'lazy'; img.className = 'cb-card-logo' + (LOGOS[key][1] ? ' inv' : '') + (LOGOS[key][2] ? ' sq' : ''); c.appendChild(img); }
      var lbl = c.querySelector('.product-label-container'), price = c.querySelector('.price__default') || c.querySelector('.price');
      if (lbl && price) price.parentElement.insertBefore(lbl, price.nextSibling);
      var link = c.querySelector('a[href*="/products/"]'); var m = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
      var pk = m && picks && picks[m[1]];
      var mock = (location.search.match(/[?&]cbmock=2/) || [])[0];
      if (mock && !pk && idx < 8) pk = { score: [8.9, 9.4, 8.7, 8.8][idx % 4], url: 'https://www.batreviews.com/best/' };
      if (pk) {
        var variant = mock ? ['a', 'b', 'c', 'd'][idx % 4] : (window.cbPickStyle || 'c');
        var t = document.createElement('a'); t.className = 'cb-card-pick cb-pick-' + variant; t.href = pk.url || 'https://www.batreviews.com/best/'; t.target = '_blank'; t.rel = 'noopener'; t.title = 'BatReviews.com score ' + pk.score + '/10';
        var sc = pk.score ? String(pk.score) : '';
        if (variant === 'a') t.innerHTML = '<span class="cbp-med">' + sc + '</span><span class="cbp-txt"><i>BatReviews.com</i><b>Top Pick</b></span>';
        else if (variant === 'b') t.innerHTML = '<span class="cbp-star">\u2605</span><span class="cbp-txt"><i>BatReviews.com</i><b>Top Pick</b></span><span class="cbp-score">' + sc + '<small>/10</small></span>';
        else if (variant === 'c') t.innerHTML = '<span class="cbp-ring"><b>' + sc + '</b><small>/10</small></span><span class="cbp-txt"><i>BatReviews.com</i><b>Top Pick</b></span>';
        else t.innerHTML = '<span class="cbp-txt"><i>BatReviews.com</i><b>Top Pick</b><em>' + sc + ' / 10 \u00b7 read review \u2192</em></span>';
        if (mock) { var lab = document.createElement('span'); lab.className = 'cbp-lab'; lab.textContent = variant.toUpperCase(); c.appendChild(lab); }
        c.appendChild(t);
      }
    });
  };

  class CbProductsToolbar extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('cb-collection-embed'); if (!this.root) return;
      this.btn = this.querySelector('.js-toggle-filters');
      this.col = this.root.querySelector('.main-products-grid__filters');
      if (this.btn) this.btn.addEventListener('click', this.toggle.bind(this));
    }
    toggle() {
      var facets = this.root.querySelector('facet-filters');
      if (window.theme && theme.mediaMatches && theme.mediaMatches.lg) {
        this.btn.classList.toggle('is-active');
        var open = this.btn.classList.contains('is-active');
        this.btn.setAttribute('aria-expanded', open);
        if (this.col) this.col.classList.toggle('lg:js-hidden', !open);
        var list = this.root.querySelector('.main-products-grid__results > .grid');
        if (list && list.dataset.filtersOpenClasses) list.className = open ? list.dataset.filtersOpenClasses : list.dataset.filtersClosedClasses;
      } else if (facets && facets.open) {
        facets.open(this.btn);
      }
    }
  }
  // Only claim the native tag on pages that have an embed (home). On collection pages the theme's own products-toolbar.js must win.
  if (document.querySelector('cb-collection-embed') && !customElements.get('products-toolbar')) customElements.define('products-toolbar', CbProductsToolbar);

  class CbCollectionEmbed extends HTMLElement {
    connectedCallback() {
      if (this._started) return; this._started = true;
      this.section = this.closest('.cb-embed-section');
      this.rail = this.querySelector('[data-rail]');
      var pk = this.section && this.section.querySelector('script[data-cb-picks]'); this.picks = {}; try { this.picks = pk ? (JSON.parse(pk.textContent) || {}) : {}; } catch (e) {}
      this.setAttribute('data-default-url', this.dataset.url);
      this.section = this.closest('.cb-embed-section');
      if (this.rail) this.rail.addEventListener('click', this.onRailClick.bind(this));
      this.load(this.dataset.url, this.dataset.params || '');
    }
    onRailClick(evt) {
      var a = evt.target.closest('a[data-rail-url]'); if (!a) return;
      if (window.cbRailLinks || /[?&]cbmock=4/.test(location.search)) { evt.preventDefault(); evt.stopPropagation(); location.href = a.href; return; } // JustBats mode: navigate to the canonical collection (the theme's facet click handler would otherwise swallow the click)
      evt.preventDefault();
      var base = a.hasAttribute('data-rail-params') ? a.dataset.railParams : (this.dataset.params || ''); // coming-soon rail link drops the in-stock filter (qty is 0 by design)
      var params = a.dataset.railFilter ? (base ? base + '&' : '') + a.dataset.railFilter : base;
      this.rail.querySelectorAll('a.is-active').forEach(function (x) { x.classList.remove('is-active'); });
      a.classList.add('is-active');
      this.load(a.dataset.railUrl, params, a.href, !!a.dataset.railFilter);
      var top = this.section ? this.section.getBoundingClientRect().top + window.scrollY - 90 : null;
      if (top !== null && window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
    }
    async load(url, params, viewAllHref, keepFacetLinks) {
      var view = this.dataset.view || 'home-embed', key = this.dataset.key;
      var body = this.querySelector('.cb-embed__body');
      this.dataset.url = url;
      if (this.rail && this.rail.parentElement !== this) this.appendChild(this.rail); // take the rail back before wiping
      body.classList.add('is-loading');
      try {
        var res = await fetch(url + '?view=' + view + (params ? '&' + params : ''), { headers: { 'X-Requested-With': 'cb-embed' } });
        if (!res.ok) throw new Error(res.status);
        var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        var sec = doc.querySelector('[id^="shopify-section-"][id$="__collection-products"]');
        if (!sec) throw new Error('collection section not found');
        sec.querySelectorAll('script').forEach(function (s) { s.remove(); });
        var html = sec.innerHTML
          .replace(/data-infinite-scroll="true"/g, 'data-infinite-scroll="false"');
        html = window.cbSuffixIds(html, key);
        body.innerHTML = html;
        var form = body.querySelector('form[id^="facets"]');
        if (form && !form.querySelector('input[name="view"]')) {
          var inp = document.createElement('input'); inp.type = 'hidden'; inp.name = 'view'; inp.value = view; form.appendChild(inp);
        }
        this.placeRail(); // rail lives inside the facet panel (desktop column / mobile drawer)
        if (!keepFacetLinks) this.fillRailCounts();
        this.syncActiveCount();
        var va = this.section && this.section.querySelector('[data-embed-viewall]');
        if (va) va.href = viewAllHref || url;
        this.classList.add('is-loaded');
        window.cbDressCards(this, this.picks);
        var self = this, res = this.querySelector('[id^="filter-results"]');
        if (res && !res._cbObs) { res._cbObs = new MutationObserver(function () { window.cbDressCards(self, self.picks); }); res._cbObs.observe(res, { childList: true, subtree: true }); }
      } catch (e) {
        body.innerHTML = '<p class="cb-embed__fallback"><a class="btn btn--primary" href="' + url + '">Shop the full collection</a></p>';
        if (window.console) console.warn('cb-collection-embed', e);
      }
      body.classList.remove('is-loading');
    }
    placeRail() {
      if (!this.rail) return;
      var ff = this.querySelector('facet-filters .facets__filters') || this.querySelector('facet-filters form');
      if (ff) ff.insertBefore(this.rail, ff.firstChild);
    }
    // the active rail link shows the live IN-STOCK count (collection.all_products_count includes sold-out)
    syncActiveCount() {
      if (!this.rail) return;
      var n = this.querySelector('[data-num-results]'); var a = this.rail.querySelector('a.is-active');
      var out = a && a.querySelector('span'); if (n && out && n.dataset.numResults !== undefined) out.textContent = n.dataset.numResults;
    }
    // "Approved For"-style rail links: resolve the facet VALUE (S&D metaobject filters use gids) by its
    // label text, and show the live count. Only resolved on the default collection; hidden elsewhere.
    fillRailCounts() {
      if (!this.rail) return;
      var self = this, defaultUrl = this.getAttribute('data-default-url') || this.dataset.url;
      this.rail.querySelectorAll('a[data-rail-facet]').forEach(function (a) {
        var param = a.dataset.railFilter.split('=')[0], want = a.dataset.railFacet.toLowerCase(), hit = null, count = '';
        self.querySelectorAll('form[id^="facets"] input[name="' + param + '"]').forEach(function (box) {
          var lbl = box.closest('li') || box.parentElement, t = (lbl ? lbl.textContent : '').replace(/\s+/g, ' ').trim();
          var m = t.match(/^(.*?)\s*\((\d+)\)\s*$/); var name = (m ? m[1] : t).toLowerCase();
          if (!hit && name === want) { hit = box; count = m ? m[2] : ''; }
        });
        if (hit) a.dataset.railFilter = param + '=' + encodeURIComponent(hit.value);
        var out = a.querySelector('[data-rail-count]'); if (out) out.textContent = count;
        a.hidden = !hit;
      });
    }
  }
  if (!customElements.get('cb-collection-embed')) customElements.define('cb-collection-embed', CbCollectionEmbed);
})();
